import { Component } from "react";
import Input from "../../../blocks/Input";
import './payment-detail-modal.css'
import { useEffect } from "react";
import BaseModal from "../Base-modal";


const Content = ({closeModal, showModal, data}) => {
    
    
    return(
        <div className="detail">
            <div className="detail__line">
                <div className="first">
                    <label>Amount:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.amount.toLocaleString() + ' ' + data?.currency.code}</span>
                    }
                </div>
                <div className="second">
                    <label>Product:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.product.name}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Contact:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.primaryContact}</span>
                    }
                </div>
                <div className="second">
                    <label>Mobile</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.mobile}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Email</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.email}</span>
                    }
                </div>
                <div className="second">
                    <label>validity:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.validity}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Last Email delivery</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.lastEmailDelivery}</span>
                    }
                </div>
                <div className="second">
                    <label>Last SMS delivery</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.lastSmsDelivery}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Last Modification Date:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.modificationDate}</span>
                    }
                </div>
                <div className="second">
                    <label>Reference:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.reference}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Purchase ID</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.purchaseId}</span>
                    }
                </div>
                <div className="second">
                    <label>Status</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.status}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Creation Date:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.creationDate}</span>
                    }
                </div>
                <div className="second">
                    <label>Payment Type</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.paymentType}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Created By:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.createdBy?.username}</span>
                    }
                </div>
                <div className="second">
                    <label>Approved By</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.approvedBy?.username}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Account Name:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.account?.name}</span>
                    }
                </div>
                <div className="second">
                    <label>Deposit Id</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.depositId }</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Payment Reference:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.paymentReference}</span>
                    }
                </div>
                <div className="second">
                    <label>Payment Gateway Reference:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.pgwReference}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Auto Booking:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span><span>{(data?.autoBooking ? 'Yes' : 'No')}</span></span>
                    }
                </div>
                <div className="second">
                    <label>Auto Amount:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{(data?.autoAmount ? 'Yes' : 'No')}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Trace ID:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.traceId}</span>
                    }
                </div>
                <div className="second">
                    <label>Transaction DateTime:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.transactionDateTime}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Masked Pan:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.maskedPan}</span>
                    }
                </div>
                <div className="second">
                    <label>RRN:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.rrn}</span>
                    }
                </div>
            </div>
            <div className="detail__line">
                <div className="first">
                    <label>Booking Status:</label>
                    {
                        data && Object.keys(data).length !== 0 &&
                        <span>{data?.bookingStatus}</span>
                    }
                </div>
                
            </div>
            
        </div>
    )
}

class PaymentDetailModal extends Component {
    state = {
        open: false
    }

    openModal = () => this.setState({open: true})
    closeModal = () => this.setState({open: false})


    render() {
        return (
            <BaseModal open={this.state.open} closeModal={this.closeModal}>
                <Content
                    {...this.props}
                    showModal={this.state.open}
                    closeModal={this.closeModal}
                />
            </BaseModal>
        )
    }
}

export default PaymentDetailModal
